import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import ApiService from '../services/ApiService';
import NotificationService from '../services/NotificationService';
import EDSHeader from '../components/EDSHeader';
import EDSFooter from '../components/EDSFooter';

const OsobaPowiazanaPotwierdzenie = (props) => {
    const apiService = ApiService.getInstance();
    const notificationService = NotificationService.getInstance();

    const history = useHistory();

    const [activationResult, setActivationResult] = useState(null);

    useEffect(() => {
        const searchParams = new URLSearchParams(props.location.search);
        const token = searchParams.get('token');
        if (typeof token === 'string' && token.length > 0) {
            const payload = {
                resetToken: token,
            };
            apiService.apiPost(
                'ConfirmUserRelation',
                payload,
                (response) => {
                    console.log(response);
                    if (response.success) {
                        if (
                            typeof response.data.succeeded === 'boolean' &&
                            response.data.succeeded
                        ) {
                            setActivationResult(true);
                        } else {
                            notificationService.showError();
                        }

                        setActivationResult(true);
                    } else {
                        notificationService.showError();
                    }
                    // history.push('/error_token_wygasl');
                },
                false
            );
        } else {
            notificationService.showError();
        }
    }, []);

    function render() {
        return (
            <>
                <EDSHeader></EDSHeader>

                {renderContent()}

                <EDSFooter></EDSFooter>
            </>
        );
    }

    function renderContent() {
        if (activationResult) {
            return (
                <div className="content responsive-padding">
                    <main className="margin-top-64">
                        <div className="texts text-box">
                            <h2 className="h2 margin-top-16">
                                Potwierdzono rejestrację osoby powiązanej.
                            </h2>

                            <div>
                                <Link to="/">
                                    <a
                                        href=""
                                        className="btn-primary-responsive btn-primary-responsive--medium margin-top-64"
                                    >
                                        Idź do strony logowania
                                    </a>
                                </Link>
                            </div>
                        </div>
                    </main>
                </div>
            );
        } else {
            return <div className="content responsive-padding"></div>;
        }
    }

    return render();
};

export default OsobaPowiazanaPotwierdzenie;
